<template>
  <button 
    class="btn btn-primary"
    :class="{'disabled':loading}"
    :disabled="loading"
    @click="$emit('click')"
  >
    <div class="spinner-grow" v-if="loading"/>
    <slot v-if="!loading" />
  </button>
</template>

<script>
export default {
  props: ['loading']
}
</script>